export const loginFrontendPath = "/login";
export const loginBackendPath = "/backend/auth/login/";
export const logoutFrontendPath = "/logout";
export const logoutBackendPath = "/backend/auth/logout/";
export const csrfTokenBackendPath = "/backend/auth/get/csrf/";


// WEBPACK FOOTER //
// ./src/routes/auth/urls.js